import * as React from 'react';
import * as styles from './styles.css';

import { ArticleHeading4, ArticleParagraph3 } from '@cian/ui-kit';

export interface ICounter {
  label: string;
  text: string;
}

interface ICountersProps {
  counters: ICounter[];
}

export const Counters = ({ counters }: ICountersProps) => {
  return (
    <div className={styles['counters']}>
      {counters.map(({ label, text }) => (
        <div key={label} className={styles['counters-item']}>
          <ArticleParagraph3 color="gray60_100">{label}</ArticleParagraph3>
          <ArticleHeading4>{text}</ArticleHeading4>
        </div>
      ))}
    </div>
  );
};
